import path from 'node:path';
import { buildSymbolIndexAsync } from '../../code-nav/index.js';
import {
  CliSqliteInterrupted,
  CodeNavCacheUnavailableError,
} from '../../sqlite/code-nav-cache/database.js';
import { startCodeNavCacheInitialization } from '../../sqlite/code-nav-cache/code-nav-cache-availability.js';
import { getBridgeRoot } from '../cwd/index.js';
import { buildFileIndexAsync } from './build-file-index.js';

/**
 * Run the first file + symbol index builds sequentially (not in parallel) so SQLite and the
 * event loop are not contended before or during bridge handshake.
 */
export async function runInitialIndexBuilds(cwd: string = getBridgeRoot()): Promise<void> {
  const resolved = path.resolve(cwd);
  try {
    if (!(await startCodeNavCacheInitialization())) return;
    await buildFileIndexAsync(resolved);
    await buildSymbolIndexAsync(resolved);
  } catch (e) {
    if (e instanceof CliSqliteInterrupted) return;
    if (e instanceof CodeNavCacheUnavailableError) return;
    console.error('[file-index] Initial index build failed:', e);
  }
}

/** Defer {@link runInitialIndexBuilds} until after the current stack clears. */
export function scheduleInitialIndexBuilds(cwd: string = getBridgeRoot()): void {
  setImmediate(() => {
    void runInitialIndexBuilds(cwd);
  });
}
